import React from 'react';
import Image from '@/components/ui/Image';
import { cn } from '@/lib/utils';
import { SelectableImageRatios } from '@/types/content';
import { useVideo, VideoIframe } from "../components/VideoIframe";
import { Button } from '../ui/button';

interface VideoProps {
  video?: string;
  image?: string;
  altText?: string;
  imageRatio?: SelectableImageRatios;
  imageSize?: "50%" | "75%" | "100%";
  imageAlign?: string;
  caption?: string;
  captionAlign?: string;
  attributes?: React.HTMLProps<HTMLDivElement>;
}

export const VideoBlock = ({ video, image, altText, imageRatio, imageSize, imageAlign, caption, captionAlign, attributes }: VideoProps) => {
  const { key, ...rest } = attributes ?? {};
  const aspectRatio = imageRatio ? imageRatio : '16/9';
  const { isVideoOpen, getVideoThumbnail, handleVideoClick, handleCloseVideo } = useVideo();

  const sectionClass = cn(
    "content-image relative pb-6 flex flex-col",
    imageAlign === 'left' && 'items-start',
    imageAlign === 'center' && 'items-center',
    imageAlign === 'right' && 'items-end',
  );

  const imageWrapperClass = cn(
    'relative cursor-pointer',
    imageSize === '50%' && 'w-[50%]',
    imageSize === '75%' && 'w-[75%]',
    imageSize === '100%' && 'w-[100%]',
  );

  const imageClass = cn(
    'object-cover w-full rounded-lg',
  );

  const imageStyle = {
    aspectRatio: `${aspectRatio}`,
  }

  const captionClass = cn(
    "paragraph-sm italic mt-1 text-muted-foreground",
    imageSize === '50%' && 'w-[50%]',
    imageSize === '75%' && 'w-[75%]',
    imageSize === '100%' && 'w-[100%]',
    captionAlign === 'left' && 'text-left',
    captionAlign === 'center' && 'text-center',
    captionAlign === 'right' && 'text-right',
  );

  return (  
    <div
      key={key}
      {...rest}
      className={sectionClass}
    >
      {video && (
        <div className={imageWrapperClass} onClick={() => handleVideoClick(video)}>
          <Image     
            src={image || getVideoThumbnail(video) || ''} 
            alt={altText || ''} 
            title={altText || ''}
            width={800}
            height={450} 
            className={imageClass}
            style={imageStyle}
            onClick={() => handleVideoClick(video)}
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="flex items-center justify-center w-12 h-12">
              <Button variant="secondary" size="iconLg" className="absolute bottom-6 left-6 bg-muted border-2 border-white rounded-full" >
                <span className="material-symbols-outlined font-variation-filled">play_arrow</span>
              </Button>
            </div>
          </div>
          <VideoIframe
            videoUrl={video}
            isOpen={isVideoOpen}
            onClose={handleCloseVideo}
          />
        </div>
      )}
      {caption && (
        <span className={captionClass}>
          {caption}
        </span>
      )}
    </div>
  );
}; 